import React, { Component } from "react";
import { connect } from "react-redux";

import classes from "./Router.css";
import Box from "../../hoc/Box/Box";
import api from "../../axios-local-api";
import * as actions from "../../store/actions/index";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import Spinner from "../../components/UI/Spinner/Spinner";
import Pod from "../Pod/Pod";
import { FaExclamationCircle } from "react-icons/fa";
import { withRouter } from "react-router-dom";

export class Router extends Component {
  state = {};
  componentDidMount() {}
  componentWillUpdate() {}
  componentDidUpdate() {}

  onClick = () => {
    this.props.data.setEquipmentSelection({
      routerId: this.props.data.id,
      mac: this.props.data.mac,
      nickname: this.props.data.nickname,
      type: "router",
      didClick: true,
    });
    // Use the router-context history (from withRouter) so the <Switch> re-renders
    // and resets to the Overview tab. The exported `history` singleton is not
    // connected to <BrowserRouter>, so it would only change the URL bar.
    this.props.history.replace("/overview");
  };

  render() {
    let equips;
    let connectionState;
    if (
      this.props.checkingWan ||
      (this.props.data.connectionState !== undefined &&
        this.props.data.connectionState === "disconnected")
    ) {
      connectionState = <FaExclamationCircle color={"red"} />;
    }
    if (this.props.loading) {
      return <Spinner />;
    } else {
      let connectedDeviceCount;
      // console.log("checkingWan ::::", this.props.checkingWan);
      if (this.props.checkingWan) {
        connectedDeviceCount = 0;
      } else {
        connectedDeviceCount = this.props.data.connectedDeviceCount;
      }
      let routerHtml;
      if (
        this.props.selectedEquipment &&
        this.props.selectedEquipment.routerId &&
        !this.props.selectedEquipment.podId
      ) {
        routerHtml = (
          <div
            style={{ cursor: "pointer" }}
            id="routerLeftTrail"
            className={[classes.Equipment, classes.SelectedBgColor].join(" ")}
            onClick={this.onClick}
          >
            <div>
              <b>Router</b> {connectionState}
            </div>
            <div id="RouterModel">
              {/* {this.props.data.model} */}
              {this.props?.realWan?.model}
            </div>
            <div id="RouterConnectedDevices">
              connected Devices {connectedDeviceCount}
            </div>
          </div>
        );
      } else {
        routerHtml = (
          <div
            style={{ cursor: "pointer" }}
            id="routerLefTtrail"
            className={classes.Equipment}
            onClick={this.onClick}
          >
            <div>
              <b>Router</b> {connectionState}
            </div>
            <div id="RouterModel">
              {/* {this.props.data.model} */}
              {this.props?.realWan?.model}
            </div>
            <div id="RouterConnectedDevices">
              connected Devices {connectedDeviceCount}
            </div>
          </div>
        );
      }

      let pods = this.props.data.pods.map((pod) => {
        return (
          <Pod data={pod} selectedEquipment={this.props.selectedEquipment} />
        );
      });
      return (
        <Box>
          <div className={classes.Spacer} />

          {routerHtml}
          <div className={classes.pod}>{pods}</div>
        </Box>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.settings.loading,
    loaded: state.settings.loaded,
    account: state.settings.account,
    realEquipment: state.equipment.realEquipment,
    checkingWan: state.wan.checkingWan,
    realWan: state.wan.realWan,
  };
};

export default withRouter(
  connect(mapStateToProps)(withErrorHandler(Router, api))
);
